import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import en from './locales/en.json';
import tr from './locales/tr.json';

const normalizeLanguage = (lng) => {
  if (lng?.startsWith('en')) return 'en';
  if (lng?.startsWith('tr')) return 'tr';
  return 'tr';
};

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      en: { translation: en },
      tr: { translation: tr },
    },
    fallbackLng: 'tr',
    debug: false,
    detection: {
      order: ['localStorage', 'navigator'],
      lookupLocalStorage: 'i18nextLng',
      caches: ['localStorage'],
    },
    load: 'languageOnly',
    lowerCaseLng: true,
    cleanCode: true,
  });

const currentLng = 'tr';
const normalizedLng = normalizeLanguage(currentLng);

if (currentLng !== normalizedLng) {
  i18n.changeLanguage(normalizedLng);
}

export default i18n;
